import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";

@Injectable({
    providedIn: 'root'
})
export class OpenPersonService {

    constructor(private httpClient: HttpClient) {
    }

    addOpenPerson(eventId: string, personId: string): Observable<void> {
        return this.httpClient.post<void>(
            Configuration.getApiBaseUrl() + "/openperson/events/" + eventId + "/open-persons/" + personId,
            {}
        );
    }

    removeOpenPerson(eventId: string, personId: string): Observable<void> {
        return this.httpClient.delete<void>(
            Configuration.getApiBaseUrl() + "/openperson/events/" + eventId + "/open-persons/" + personId 
        );
    }
}